<template>
  <div>
    <b-row>
      <b-col>
        <b-button
          size="sm"
          variant="success"
          class="float-right"
          @click="handleSavePagesClick"
        >
          Save Pages
        </b-button>
      </b-col>
    </b-row>
    <b-row style="margin-top: 10px">
      <b-col>
        <b-card no-body>
          <b-tabs card v-if="filteredPages && Array.isArray(filteredPages)">
            <!-- Render Tabs for Pages, supply a unique `key` to each tab -->
            <b-tab
              v-for="(aPage, i) in filteredPages"
              :key="`dyn-tab-${i}`"
              :title="aPage.pageName"
            >
              <page-form
                v-if="aPage"
                :page="aPage"
                @content-update="handleContentUpdate"
                @remove-page="handleRemovePage"
                @page-name-change="handlePageNameChange"
              />
            </b-tab>

            <!-- New Page Button (Using pages-end slot) -->
            <template #tabs-end>
              <b-nav-item
                role="presentation"
                @click.prevent="handleAddPageClick"
                href="#"
              >
                <b>+</b></b-nav-item
              >
            </template>

            <!-- Render this if no pages -->
            <template #empty>
              <div class="text-center text-muted">
                There are no open page<br />
                Add a new page using the <b>+</b> button above.
              </div>
            </template>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageForm from "./pageForm";
export default {
  name: "SettingsPages",
  components: {
    PageForm
  },
  props: {
    publishing: {
      type: Object,
      default: () => {}
    },
    resource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      inputVideoURLDisabled: false,
      tabCounter: null,
      pages: []
    };
  },
  watch: {
    settings(newVal, oldVal) {
      //console.log(`New Val:${newVal}`);

      if (newVal && newVal.pages) {
        //be careful not to overwrite data
        this.pages = newVal.pages;
      } else {
        this.pages = [];
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    settings() {
      return this.resource && this.resource.data && this.resource.data.settings
        ? this.resource.data.settings
        : null;
    },
    filteredPages() {
      return this.pages && Array.isArray(this.pages)
        ? this.pages.filter(aPage => {
            return !aPage.hasOwnProperty("_deleted_at");
          })
        : [];
    }
  },
  methods: {
    handleAddPageClick() {
      if (this.tabCounter === null) this.tabCounter = this.pages.length;
      this.pages.push({
        idx: this.tabCounter,
        pageName: `page-${this.tabCounter}`,
        content: []
      });
      this.tabCounter++;
    },
    handleRemovePage(page) {
      for (let i = 0; i < this.pages.length; i++) {
        if (this.pages[i].idx === page.idx) {
          this.pages.splice(i, 1);
        }
      }
    },
    handlePageNameChange(page, pageName) {
      for (let i = 0; i < this.pages.length; i++) {
        if (this.pages[i].idx === page.idx) {
          this.pages[i].pageName = pageName;
        }
      }
    },
    handleContentUpdate(page, content) {
      for (let i = 0; i < this.pages.length; i++) {
        if (this.pages[i].idx === page.idx) {
          this.pages[i].content = content;
        }
      }
    },
    handleSavePagesClick() {
      this.handleItemForParentProperty("pages", this.pages, null, null);
    },
    handleItemForParentProperty(
      propertyName,
      item,
      parentPropertyName,
      parentPropertyId
    ) {
      //console.log(`Property: ${propertyName} and Item: ${item}`);
      //console.log(`Parent Property: ${parentPropertyName} and Id: ${parentPropertyId}`);

      const payload = {
        publishingId: this.publishing.id,
        resourceId: this.resource.toolId,
        parentPropertyName: parentPropertyName,
        parentPropertyId: parentPropertyId,
        propertyName: propertyName,
        resourceItem: item
      };

      this.$store
        .dispatch("resources/addResourceIntoSettingsParentProperty", payload)
        .then(response => {
          this.add = true;
          //this.$bvModal.hide(this.productModal);

          this.$store.dispatch("user/showNotification", {
            title: `Updated ${payload.name}`,
            description: "",
            variant: "success"
          });

          this.$emit("added-resource-item");
        });
    }
  },
  mounted() {
    if (this.settings) {
      this.pages = this.settings.pages ? this.settings.pages : [];
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  // justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  .notification-content {
    margin-left: 14px;
    cursor: pointer;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;

      color: #8d99a0;
      margin: 0;
    }
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;

      display: flex;
      align-items: center;
      color: #474d52;
      @media (max-width: 874px) {
        margin-bottom: 0px;
      }
    }
  }
  .toggler {
    @media (max-width: 874px) {
      margin-bottom: 10px;
      margin-left: 15px;
    }
    position: relative;
    display: inline-block;
    width: 46.5px;
    height: 24px;
    background: #f3f6f9;
    border-radius: 18px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background: #b3c2cb;
    box-shadow: 0px 3px 9px #c4c4c4;

    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
  .bg {
    background: rgba(85, 126, 251, 0.1);
  }
  .btns {
    left: 50%;
    background: var(--theme-color);
    box-shadow: 0px 3px 9px rgba(85, 126, 251, 0.24);
  }
}
</style>
